import * as types from './actionTypes';


export const get = (activityType, contactId) =>{
	return{
    type: types.GET_WAGE_RATE_LIST_REQUEST,
    activityType,
    contactId
  }
};

export const getSuccess = data => {
	return {
		type: types.GET_WAGE_RATE_LIST_SUCCESS,
		payLoad: data
	};
};
export const getFailure = data => {
	return {
		type: types.GET_WAGE_RATE_LIST_FAILURE,
		payLoad: data
	};
};

// export const getListRequest =(contactId) =>{
//   return {
//     type: types.WAGE_RATE_ALL_REQUEST,
//     contactId
//   }
// };
// export const getListSuccess =(data) =>{
//   return {
//     type: types.WAGE_RATE_ALL_SUCCESS,
//     payLoad:data
//   }
// };
// export const getListFailure =(data) =>{
//   return {
//     type: types.WAGE_RATE_ALL_FAILURE
//   }
// };

export const remove = (id, contactId, dailyActivityData ) =>{
	return{
    type: types.WAGE_RATE_DELETE_REQUEST,
    id,
    contactId,
    dailyActivityData
  }
};

export const removeSuccess = (data, id) => {
	return {
		type: types.WAGE_RATE_DELETE_SUCCESS,
		payLoad: data,
		id
	};
};
export const removeFailure = data => {
	return {
		type: types.WAGE_RATE_DELETE_FAILURE,
		payLoad: data
	};
};

export const create = (data, contactId, dailyActivityData) =>{
	return{
    type: types.WAGE_RATE_CREATE_REQUEST,
    data,
    contactId,
    dailyActivityData
  }
};

export const createSuccess = data => {
	return {
		type: types.WAGE_RATE_CREATE_SUCCESS,
		payLoad: data
	};
};
export const createFailure = data => {
	return {
		type: types.WAGE_RATE_CREATE_FAILURE,
		payLoad: data
	};
};

export const update = (data, contactId, wageRateId, activityType ) =>{
	return{
    type: types.WAGE_RATE_UPDATE_REQUEST,
    data,
    contactId,
    activityType,
    wageRateId
  }
};
export const updateSuccess = data => {
	return {
		type: types.WAGE_RATE_UPDATE_SUCCESS,
		payLoad: data
	};
};
export const updateFailure = data => {
	return {
		type: types.WAGE_RATE_UPDATE_FAILURE,
		payLoad: data
	};
};